import { Div } from "../../../base/components/native/div"
import * as styles from "./upload-button.style"

export const UploadButton = (text: string) => {

    const base = Div(text)
    base.cssClass(styles.baseStyle)

    base.el.addEventListener('click', () => {
        base.emit('click')
    })

    return base
}
